
export const BID_USER_LOGIN_USER = 'BID_USER_LOGIN_USER'

